<script>
	/**
	 * @type {() => void}
	 */
	import { onDestroy, onMount } from 'svelte';
	import { closeModal } from 'svelte-modals';
	import { setCookieConsent } from '$lib/stores/app/actions';
	import ModalAbcmouse from '$lib/components/ModalAbcmouse.svelte';

	export let modalImageSrc;

	export let config = {
		textHeader: 'Do Not Sell My Info',
		sectionOneHeading: 'Do Not Sell My Information',
		sectionOneText:
			'We take your privacy very seriously and will never monetize the Personal Information of any User of our Services by providing it to a third party in exchange for money. The California Consumer Privacy Act (CCPA) has a broader definition of the term “sell” which includes disclosing Personal Information to any third party for valuable consideration. When we work with our advertising partners we are disclosing certain information such as cookies for their services, which are of value to us. Under the CCPA you have the right to opt-out of our disclosure of your Personal Information to third parties for monetary or other valuable consideration. You may exercise your right to opt-out through the settings on this page. However, please note that if you opt-out you will not receive special discounts or offers that may be of interest to you. In addition, if you opt-out, but come back to our site through a different browser or device we will not be able to recognize you, so you will still have to opt out again.',
		sectionTwoHeading: 'Manage Cookie Preferences',
		sectionTwoSubheadingOne: 'Sale of Personal Information Opt-Out',
		sectionTwoSubheadingOneText:
			'We take your privacy very seriously and will never monetize the Personal Information of any User of our Services by providing it to a third party in exchange for money. The California Consumer Privacy Act (CCPA) has a broader definition of the term “sell” which includes disclosing Personal Information to any third party for valuable consideration. When we work with our advertising partners we are disclosing certain information such as cookies for their services, which are of value to us. Under the CCPA you have the right to opt-out of our disclosure of your Personal Information to third parties for monetary or other valuable consideration. You may exercise your right to opt-out through the settings on this page. However, please note that if you opt-out you will not receive special discounts or offers that may be of interest to you. In addition, if you opt-out, but come back to our site through a different browser or device we will not be able to recognize you, so you will still have to opt out again.',
		sectionTwoSubheadingTwo: 'Analytics and Performance Cookies',
		sectionTwoSubheadingTwoText:
			'These cookies are used to collect information about traffic to our Services and how users use the Services. The information gathered does not identify any individual visitor. It includes the number of visitors to our Services, the websites that referred them to our Services, the pages they visited on our Services, what time of day they visited our Services, whether they have visited our Services before, and other similar information. We use this information to help operate our Services more efficiently, to gather broad demographic information, and to monitor the level of activity on our Services.',
		sectionTwoSubheadingThree: 'Targeting Cookies',
		sectionTwoSubheadingThreeText:
			'These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.',
		sectionTwoSubheadingFour: 'Functionality Cookies',
		sectionTwoSubheadingFourText:
			'These cookies allow us to remember choices you make when you use our Services, such as remembering your language preferences, remembering your login details, and remembering the changes you make to other parts of Services which you can customize. The purpose of these cookies is to provide you with a more personal experience and to avoid you having to re-enter your preferences every time you visit our Services.',
		sectionTwoSubheadingFive: 'Essential Cookies',
		sectionTwoSubheadingFiveText:
			'These cookies are essential to provide you with services available through Services and to enable you to use some of its features. For example, they allow you to log in to secure areas of our Services and help the content of the pages you request load quickly. Without these cookies, the services that you have asked for cannot be provided, and we only use these cookies to provide you with those services.',
		textAlwaysActive: 'Always Active',
		textButton: 'Confirm Opt-Out'
	};

	function handleConfirmOptOut() {
		setCookieConsent(false);

		closeModal();
	}

	onMount(() => {
		window.addEventListener('global:backdrop-click', closeModal);
	});

	onDestroy(() => {
		window.removeEventListener('global:backdrop-click', closeModal);
		history.replaceState(null, null, window.location.pathname);
	});
</script>

<ModalAbcmouse customModalWidth="62rem" hideModalClose>
	<header
		class="text-[2.6rem] font-bold leading-[1.6rem] text-white sm:text-[2.9rem] sm:leading-[2.9rem]"
		slot="modal-header-title"
	>
		<img
			id="modal-close-button"
			data-track-id="modal-dnsmi-close-button"
			class="modal-close-button absolute right-4 top-3 w-[2.5rem] sm:w-[4rem] h-auto"
			height="10"
			width="10"
			src="/assets-mkt/template/modal-close-button/abc_popup_close_btn.svg"
			on:click={closeModal}
			on:keydown={closeModal}
			alt="Modal Close"
		/>
		{@html config.textHeader}
	</header>
	<div slot="modal-content" class="flex justify-center">
		<div
			class="flex h-[60rem] w-full flex-col overflow-y-auto rounded-bl-[3rem] rounded-br-[3rem] bg-white px-[4rem] pb-[1rem] pt-[1rem] font-arial sm:h-[72rem]"
		>
			<img class="my-12 h-[4.7rem] w-[29.7rem]" src={modalImageSrc} alt="ABCmouse logo" />

			<h2 class="mb-[1rem] font-arial text-[2.4rem]">{config.sectionOneHeading}</h2>
			<p class="mb-[3rem] text-[1.8rem]">{config.sectionOneText}</p>

			<h2 class="mb-[1rem] font-arial text-[2.4rem]">{config.sectionTwoHeading}</h2>
			<h3 class="mb-[1rem] font-arial text-[1.8rem]">{config.sectionTwoSubheadingOne}</h3>
			<p class="mb-[3rem] text-[1.8rem]">{config.sectionTwoSubheadingOneText}</p>

			<h3 class="mb-[1rem] pl-10 font-arial text-[1.8rem]">{config.sectionTwoSubheadingTwo}</h3>
			<p class="mb-[3rem] pl-10 text-[1.8rem]">{config.sectionTwoSubheadingTwoText}</p>

			<h3 class="mb-[1rem] pl-10 font-arial text-[1.8rem]">{config.sectionTwoSubheadingThree}</h3>
			<p class="mb-[3rem] pl-10 text-[1.8rem]">{config.sectionTwoSubheadingThreeText}</p>

			<div class="mb-[1rem] flex justify-between">
				<h3 class="font-arial text-[1.8rem]">{config.sectionTwoSubheadingFour}</h3>
				<h3 class="font-arial text-[1.8rem] text-[#033EAA]">{config.textAlwaysActive}</h3>
			</div>
			<p class="mb-[3rem] text-[1.8rem]">{config.sectionTwoSubheadingFourText}</p>

			<div class="mb-[1rem] flex justify-between">
				<h3 class="font-arial text-[1.8rem]">{config.sectionTwoSubheadingFive}</h3>
				<h3 class="font-arial text-[1.8rem] text-[#033EAA]">{config.textAlwaysActive}</h3>
			</div>
			<p class="mb-[3rem] text-[1.8rem]">{config.sectionTwoSubheadingFiveText}</p>

			<div>
				<button
					id="confirm-opt-out"
					class="btn-primary-blue mx-auto mb-20 mt-6 h-[4.2rem] w-[22.4rem] overflow-visible text-[2rem] sm:h-[4.6rem] sm:w-[26.5rem] sm:text-[2.4rem]"
					type="submit"
					on:click|preventDefault={handleConfirmOptOut}
				>
					{config.textButton}
				</button>
			</div>
		</div>
	</div>
</ModalAbcmouse>
